export const PERMISSIONS = [
  { module: "Building Management", role: "SUPER_ADMIN", create: true, edit: true, delete: true, view: true },
  { module: "Building Management", role: "MODERATOR", create: false, edit: false, delete: false, view: true },
  { module: "Building Management", role: "BUILDING_ADMIN", create: false, edit: true, delete: false, view: true },
  { module: "Building Management", role: "BUILDING_MODERATOR", create: false, edit: false, delete: false, view: true },

  { module: "User Management", role: "SUPER_ADMIN", create: true, edit: true, delete: true, view: true },
  { module: "User Management", role: "MODERATOR", create: false, edit: false, delete: false, view: true },
  { module: "User Management", role: "BUILDING_ADMIN", create: true, edit: true, delete: true, view: true },
  { module: "User Management", role: "BUILDING_MODERATOR", create: false, edit: false, delete: false, view: false },

  { module: "Floor Management", role: "SUPER_ADMIN", create: true, edit: true, delete: true, view: true },
  { module: "Floor Management", role: "MODERATOR", create: false, edit: false, delete: false, view: true },
  { module: "Floor Management", role: "BUILDING_ADMIN", create: true, edit: true, delete: true, view: true },
  { module: "Floor Management", role: "BUILDING_MODERATOR", create: false, edit: false, delete: false, view: true },

  { module: "Global Application", role: "SUPER_ADMIN", create: true, edit: true, delete: true, view: true },
  { module: "Global Application", role: "MODERATOR", create: false, edit: false, delete: false, view: true },
  { module: "Global Application", role: "BUILDING_ADMIN", create: false, edit: false, delete: false, view: false },
  { module: "Global Application", role: "BUILDING_MODERATOR", create: false, edit: false, delete: false, view: false },

  { module: "My Profile", role: "SUPER_ADMIN", create: true, edit: true, delete: true, view: true },
  { module: "My Profile", role: "MODERATOR", create: false, edit: true, delete: false, view: true },
  { module: "My Profile", role: "BUILDING_ADMIN", create: false, edit: true, delete: false, view: true },
  { module: "My Profile", role: "BUILDING_MODERATOR", create: false, edit: true, delete: false, view: true },

  { module: "Customer Management", role: "SUPER_ADMIN", create: true, edit: true, delete: true, view: true },
  { module: "Customer Management", role: "MODERATOR", create: false, edit: false, delete: false, view: true },
  { module: "Customer Management", role: "BUILDING_ADMIN", create: false, edit: false, delete: false, view: false },
  { module: "Customer Management", role: "BUILDING_MODERATOR", create: false, edit: false, delete: false, view: false },

  { module: "Device Management", role: "SUPER_ADMIN", create: true, edit: true, delete: true, view: true },
  { module: "Device Management", role: "MODERATOR", create: false, edit: false, delete: false, view: true },
  { module: "Device Management", role: "BUILDING_ADMIN", create: false, edit: true, delete: false, view: true },
  { module: "Device Management", role: "BUILDING_MODERATOR", create: false, edit: false, delete: false, view: true }
];

function isAccess(role, module) {
  const access = PERMISSIONS.find(p => p.role === role && p.module === module);
  if (access) {
    return {
      create: access.create,
      edit: access.edit,
      delete: access.delete,
      view: access.view
    };
  } else {
    return { create: true, edit: true, delete: true, view: true };
  }
}

export default isAccess;